import { readonly } from 'vue';
import { useBrand } from '~/composables/useBrand';
import useKillswitches from '~/modules/featureControl/composables/useKillswitches';

export const useBagContext = () => {
  const { query } = useRoute();
  const { isBcom } = useBrand();
  const { killswitches } = useKillswitches();

  const isUpdateBagEnabled = killswitches.featureEnabledC && isBcom && query?.EXTRA_PARAMETER === 'BAG';
  const sequenceNumber = isUpdateBagEnabled && query?.seqNo ? Number.parseInt(query?.seqNo, 10) : 0; // 0 - is fallback value

  return readonly({
    isUpdateBagEnabled,
    sequenceNumber,
  });
};
